__turbopack_context__.v({
  "loader": "loader-module-scss-module__cVSDDW__loader",
  "loader--is-inner": "loader-module-scss-module__cVSDDW__loader--is-inner",
  "loader--with-text": "loader-module-scss-module__cVSDDW__loader--with-text",
  "loader__logo-container": "loader-module-scss-module__cVSDDW__loader__logo-container",
  "loader__logo-container--centered": "loader-module-scss-module__cVSDDW__loader__logo-container--centered",
  "loader__text-container": "loader-module-scss-module__cVSDDW__loader__text-container",
});
